import React from 'react';
import Link from 'next/link';
import { Col } from 'react-bootstrap';
import { Block } from '@views/components/block/Block';
import WelcomeIcon from '@views/static/welcome.svg';

export default function Error({ statusCode }) {
  return (
    <Block isSection isFixedHeight isFlexCenter className="mb-4">
      <Col xs={8} md={5} lg={4} className="ml-md-4 mt-4 mb-4 pt-4 pt-md-0">
        <WelcomeIcon style={{ width: '100%' }} />
      </Col>
      <Col xs={12} md={5} lg={6}>
        <div className="not-found mt-4">
          <h1 className="not-found__title">{statusCode}</h1>
          <p className="not-found__text">
            {statusCode === 404
              ? 'Xin lỗi, trang bạn đang tìm kiếm không tồn tại!.'
              : 'Có lỗi xảy ra, vui lòng tải lại trang'}
          </p>
        </div>
        <div className="mb-4">
          <Link href="/">
            <a className="text-info">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="fill-info"
                width="4.5"
                height="6"
                viewBox="0 0 4.5 6"
              >
                <path d="M3 0l3 4.5H0z" transform="rotate(-90 3 3)" />
              </svg>
              <span className="ml-2">Quay lại trang chủ</span>
            </a>
          </Link>
        </div>
      </Col>
    </Block>
  );
}
